import React, { useContext } from 'react';
import PropTypes from 'prop-types';
import { NavItem } from 'reactstrap';
import { NavLink } from 'react-router-dom';
/*
import NavbarDropdown from './NavbarDropdown';
import NavbarDropdownComponents from './NavbarDropdownComponents';
import {
    homeRoutes,
    blogRoutes,
    flashcardsRoutes,
    googleGCPRoutes,
  authenticationRoutes,
  chatRoutes,
  componentRoutes,
  ECommerceRoutes,
  emailRoutes,
  pageRoutes,
  pluginRoutes,
  utilityRoutes,
  widgetsRoutes,
  kanbanRoutes,
  calenderRoutes
} from '../../csflashcard_routes';
 */
import { breakpoints, /*getPageName*/ } from '../../helpers/utils';
import { navbarBreakPoint, topNavbarBreakpoint } from '../../config';
import AppContext from '../../context/Context';

const MLScanNavbarTopDropDownMenus = ({ setNavbarCollapsed, setShowBurgerMenu }) => {
  const { isCombo, isTopNav } = useContext(AppContext);

    //const blogs = [blogRoutes];
    //const gcpProjects = [googleGCPRoutes];
    //const flashcards = [flashcardsRoutes];

  //const components = [componentRoutes, pluginRoutes, utilityRoutes, flashcardsRoutes];
  //const pages = [pageRoutes, calenderRoutes, kanbanRoutes, widgetsRoutes, chatRoutes, emailRoutes, ECommerceRoutes];
  //const pages = [widgetsRoutes];

  const handleSetNavbarCollapsed = () => {
      const windowWidth = window.innerWidth;
      //isTopNav && !isCombo && windowWidth < breakpoints[topNavbarBreakpoint] && setNavbarCollapsed(false);
      isTopNav && windowWidth < breakpoints[topNavbarBreakpoint] && setNavbarCollapsed(true);
      isCombo && windowWidth < breakpoints[navbarBreakPoint] && setShowBurgerMenu(false);
  };

  //const isLanding = getPageName('landing');
  return (
    <>
      {/*
      <NavbarDropdown
        title={homeRoutes.name}
        items={homeRoutes.children}
        handleSetNavbarCollapsed={handleSetNavbarCollapsed}
      />
      */}

      {/*
      <NavbarDropdown
        title={flashcardsRoutes.name}
        items={[flashcardsRoutes]}
        handleSetNavbarCollapsed={handleSetNavbarCollapsed}
      />
      */}

      {/*
      <NavbarDropdown title={pageRoutes.name} items={pages} handleSetNavbarCollapsed={handleSetNavbarCollapsed} />
      */}

      <NavItem onClick={handleSetNavbarCollapsed}>
          <NavLink className="nav-link" to="/by_range">
            交易區間
          </NavLink>
      </NavItem>

      <NavItem onClick={handleSetNavbarCollapsed}>
          <NavLink className="nav-link" to="/by_volume">
            交易量
          </NavLink>
      </NavItem>

      <NavItem onClick={handleSetNavbarCollapsed}>
          <NavLink className="nav-link" to="/by_industry">
            產業
          </NavLink>
      </NavItem>

      {/*
      <NavbarDropdownComponents
        title={blogRoutes.name}
        items={blogs}
        handleSetNavbarCollapsed={handleSetNavbarCollapsed}
      />

      <NavbarDropdownComponents
        title={googleGCPRoutes.name}
        items={gcpProjects}
        handleSetNavbarCollapsed={handleSetNavbarCollapsed}
      />

      <NavbarDropdownComponents
        title={flashcardsRoutes.name}
        items={flashcards}
        handleSetNavbarCollapsed={handleSetNavbarCollapsed}
      />
      */}

    </>
  );
};

MLScanNavbarTopDropDownMenus.propTypes = { setNavbarCollapsed: PropTypes.func.isRequired };

export default MLScanNavbarTopDropDownMenus;
